import React, {useEffect, useRef} from 'react';
import {IconButton} from "@mui/material";
import {IconClip} from "../buttons/IconButtons";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";
import {FILE_TYPE} from "../../Helpers/fileType";

/**
 *
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer - IBL
 * @Email : kpozos@ibl.mx
 *
 * @param {string} id File input identifier.
 * @param {Object} accept Allowed file configuration (extensions, validation regex, and max size).
 * @param {boolean} disabled Indicates whether the file input is disabled.
 * @param {Function} handleFile Callback executed when a valid file is selected.
 * @param {boolean} clear Flag to clear the file input.
 * @param {Function} setClear Function to reset the clear flag after clearing the input.
 */
const CustomFileUploadClip = ({
                              id = "fu_cfuc_file",
                              accept = FILE_TYPE.IMAGE,
                              disabled = false,
                              handleFile,
                              clear,
                              setClear
                          }) => {
    const fileInputRef = useRef(null);
    const {t} = useTranslation();

    useEffect(() => {
        if(clear && fileInputRef.current){
            fileInputRef.current.value = null;
            setClear(false);
        }
    }, [clear])

    /**
     * handler to validate and select files
     */
    const onFileChange = async  (e) => {
        const selectedFiles = e.target.files;
        const regex = accept.regex

        if(!fileInputRef.current || !selectedFiles || selectedFiles?.length <= 0){
            return ;
        }
        for (const file of e.target.files) {
            if (!regex.test(file.name)) {
                toast.warning(t('error_file_format'));
                fileInputRef.current.value = null;
                return;
            } else if (file.size > accept.size) {
                toast.warning(`${t('the_file_size_should_not_exceed')} ${accept.size / 1024}KB.`);
                fileInputRef.current.value = null;
                return;
            } else {
                handleFile(file)
            }
        }
        fileInputRef.current.value = null;
    };

    return (
        <label className='d-flex align-items-center'>
            <IconButton component='span'>
                <IconClip className='h-24px w-24px' />
            </IconButton>
            <input
                id={id}
                ref={fileInputRef}
                type='file'
                className='d-none'
                accept={accept.accept}
                onChange={onFileChange}
                disabled={disabled}
            />
        </label>
    )
}

export default CustomFileUploadClip
